/**
 * 标准二方包提供的默认 api 地址
 */
export var defaultCnUploadRequestConfig = { url: '/api/tars2/file/upload/getUploadFileScrip' };
/**
 * 限制最大上传数量
 */
export var CN_UPLOAD_LIMIT_NUM = 999;
